export const DEFAULT_LOCALE = {
  language: 'en',
  language_str: 'English',
  region: 'US',
  locale: 'en_US',
};
export const REACT_LOCALES = ['en_US', 'fr_FR'];
export const LANGUAGE_LOCAL_STORAGE = 'marsha-language';
